"use client";

import { type ReactNode } from 'react';

import { Heading, type HeadingProps } from '@chakra-ui/react';

import { r_400_54_normal } from '@/styles/fontStyles';

interface RoslindaleTextProps {
  children: ReactNode;
  customStyle?: Record<string, unknown>;
  headingType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  color?: string;
  fontFamily?: string;
  fontWeight?: string;
  fontSize?: string;
  lineHeight?: string;
}

export const RoslindaleText = ({
  children,
  customStyle,
  headingType = 'p',
  color,
  ...rest
}: RoslindaleTextProps) => {
  const headingProps: HeadingProps & Record<string, unknown> = {
    ...r_400_54_normal,
    ...customStyle,
    ...rest
  };
  
  if (color) {
    headingProps.color = color;
  }
  
  return (
    <Heading as={headingType} {...headingProps}>
      {children}
    </Heading>
  );
};
